import { hideElement, showElement, scrollToTarget } from './helpers/css-utils'
import { checkEnableButton, addTouchedEventListener } from './validations'
import './jquery'

/* eslint-disable-next-line no-unused-vars */
export default class MultiStepForm {
  static get instance() {
    return this.singleton || null
  }

  static set instance(inst) {
    this.singleton = inst
  }

  /**
   * Constructor with wizard container
   * @param {String} selector wizard class
   */
  constructor(selector) {
    this.constructor.instance = this
    this.currentWizard = selector || $('.wizard')
    this.form = $('form', this.currentWizard)
    this.currentStepFormFields = null
    this.currentStepNextOrSubmitButton = null
    this.initWizard()
  }

  initWizard() {
    this.currentStepFormFields = this.getElementsToValidate()
    this.currentStepNextOrSubmitButton = this.getNextOrSubmitButton()
    this.addEventListeners()
  }

  addEventListeners() {
    $('.next-step', this.currentWizard).click(() => this.handleNextClick())
    $('.next-step', this.currentWizard).on('keypress', (element) => {
      if (element.which === 13) { this.handleNextClick() }
    })

    $('.previous-step', this.currentWizard).click(() => this.handleBackClick())
    this.form.on('keyup change paste', () => {
      checkEnableButton(this.currentStepFormFields, this.currentStepNextOrSubmitButton)
      this.updateSummary()
    })
    addTouchedEventListener(this.getFormElementsOfAllSteps())
  }

  handleNextClick() {
    const nextButtonDisabled = $('.active .next-step').hasClass('disabled')
    if (nextButtonDisabled) {
      return
    }
    this.goToNextStep()
  }

  handleBackClick() {
    this.goToPreviousStep()
  }

  goToNextStep() {
    const currentStep = $('.active', this.currentWizard)
    const nextStep = $('.active', this.currentWizard).next()
    this.handlePageSwitch(currentStep, nextStep)
  }

  goToPreviousStep() {
    const currentStep = $('.active', this.currentWizard)
    const previousStep = $('.active', this.currentWizard).prev()
    this.handlePageSwitch(currentStep, previousStep)
  }

  goToStep(targetStep) {
    // Hide all other steps first
    const currentStep = $('.active', this.currentWizard)
    // Init target step
    this.handlePageSwitch(currentStep, targetStep)
  }

  handlePageSwitch(currentStep, targetStep) {
    currentStep.removeClass('active')
    targetStep.addClass('active')
    hideElement(currentStep)
    showElement(targetStep)
    this.currentStepFormFields = this.getElementsToValidate()
    this.currentStepNextOrSubmitButton = this.getNextOrSubmitButton()

    this.animatePageSwitch()
  }

  /* eslint-disable class-methods-use-this */
  animatePageSwitch() {
    scrollToTarget('#top')
  }

  getElementsToValidate() {
    return $('form input:visible, form select:visible', '.wizard')
  }

  getNextOrSubmitButton() {
    return $('.active .next-step, .active .wizard-submit')
  }

  getFormElementsOfAllSteps() {
    return $('form input, form select', '.wizard')
  }

  updateSummary() {
    const allInputs = $('[id^=user]')
    if (allInputs) {
      allInputs.each((key, obj) => {
        const newId = obj.id.replace('user_', 'summary_')
        const newObj = $(`#${newId}`)
        if (newObj && newObj.length > 0) {
          newObj.text(obj.value)
        }
      })
    }
  }

  /* eslint-enable class-methods-use-this */
}
